<template>
  <div>
    <RouterView />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['getVerificationRequests']),
  },
  watch: {
    getVerificationRequests: {
      handler(val) {
        if (val && val.length) {
          document.title = `${val[0].client_user.name}`
        }
      },
    },
  },
  mounted() {
    document.title = 'Finish Verifying Your Employment'
  },
}
</script>
